var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 527,
    viewBox: "0 0 1600 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1093.91 396.965L863.451 86.8452C831.192 43.4302 775.665 43.4302 743.406 86.8452L512.96 396.965H1093.91Z",
    fill: "url(#paint0_linear_107_46780)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M793.905 393.797L606.263 188.909C579.992 160.224 534.781 160.224 508.526 188.909L320.884 393.797H793.905Z",
    fill: "url(#paint1_linear_107_46780)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.93 393.797L1079.28 188.909C1053.01 160.224 1007.8 160.224 981.546 188.909L793.904 393.797H1266.93Z",
    fill: "url(#paint2_linear_107_46780)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1600 425.467V526.571H0V425.467C213.364 390.095 493.379 368.631 800 368.631C1106.62 368.631 1386.64 390.095 1600 425.467Z",
    fill: "#1CD75E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.876 426.762H196.571V484.907H212.876V426.762Z",
    fill: "url(#paint3_linear_107_46780)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.278 452.323C234.008 452.323 256.487 414.921 256.487 368.784C256.487 322.646 234.008 285.244 206.278 285.244C178.548 285.244 156.068 322.646 156.068 368.784C156.068 414.921 178.548 452.323 206.278 452.323Z",
    fill: "url(#paint4_linear_107_46780)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M587.002 310.851C586.774 308.125 583.878 305.977 580.313 305.977C576.701 305.977 573.745 308.201 573.608 310.989C565.486 313.319 559.665 319.626 559.665 327.044V372.912H601.433V327.044C601.433 319.474 595.368 313.06 587.002 310.851Z",
    fill: "url(#paint5_linear_107_46780)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M638.263 310.851C638.034 308.125 635.139 305.977 631.573 305.977C627.962 305.977 625.006 308.201 624.869 310.989C616.747 313.319 610.926 319.626 610.926 327.044V372.912H652.693V327.044C652.693 319.474 646.644 313.06 638.263 310.851Z",
    fill: "url(#paint6_linear_107_46780)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M689.539 310.851C689.311 308.125 686.415 305.977 682.85 305.977C679.238 305.977 676.282 308.201 676.145 310.989C668.023 313.319 662.202 319.626 662.202 327.044V372.912H703.97V327.044C703.97 319.474 697.905 313.06 689.539 310.851Z",
    fill: "url(#paint7_linear_107_46780)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M589.547 299.198H630.659V305.977H632.488V299.198H673.844C678.431 299.198 682.164 302.245 682.164 305.977H683.993C683.993 301.422 679.437 297.705 673.844 297.705H589.547C583.955 297.705 579.398 301.422 579.398 305.977H581.227C581.227 302.245 584.96 299.198 589.547 299.198Z",
    fill: "url(#paint8_linear_107_46780)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.78 344.182V343.908C1033.78 337.708 1028.74 332.666 1022.54 332.666H960.717C954.515 332.666 949.471 337.708 949.471 343.908H950.035C947.307 345.172 945.783 346.589 945.783 348.066V374.74H1037.46V348.066C1037.47 346.695 1036.16 345.37 1033.78 344.182ZM1032.21 343.466C1029.9 342.521 1026.88 341.653 1023.31 340.922V334.265C1028.15 334.646 1031.99 338.591 1032.21 343.466ZM1021.75 340.617C1019.51 340.191 1017.07 339.825 1014.48 339.505V334.235H1021.75V340.617ZM1004.1 337.434C1002.51 336.824 999.955 336.337 996.831 336.063V334.235H1004.1V337.434ZM986.438 334.235V335.986C983.482 336.184 980.953 336.58 979.17 337.083V334.235H986.438ZM961.524 334.235H968.793V339.505C966.202 339.825 963.764 340.206 961.524 340.617V334.235ZM959.955 334.265V340.922C956.389 341.653 953.372 342.521 951.056 343.466C951.284 338.591 955.124 334.646 959.955 334.265ZM976.397 338.744C974.309 338.896 972.282 339.094 970.332 339.307V334.235H977.6V337.662C976.899 337.982 976.473 338.348 976.397 338.744ZM991.117 335.819C990.05 335.819 988.998 335.849 987.993 335.895V334.235H995.261V335.956C993.951 335.865 992.564 335.819 991.117 335.819ZM1005.65 338.393V334.235H1012.92V339.307C1010.65 339.048 1008.27 338.835 1005.81 338.652C1005.78 338.576 1005.71 338.485 1005.65 338.393Z",
    fill: "url(#paint9_linear_107_46780)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M968.777 355.774H955.505V374.313H968.777V355.774Z",
    fill: "url(#paint10_linear_107_46780)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M936.945 289.311H875.932V375.821H936.945V289.311Z",
    fill: "url(#paint11_linear_107_46780)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M881.021 375.837C881.326 374.252 881.478 372.638 881.478 370.962V336.535C881.478 322.246 869.882 310.653 855.589 310.653C841.295 310.653 829.699 322.246 829.699 336.535V370.962C829.699 372.623 829.867 374.252 830.156 375.837H881.021Z",
    fill: "url(#paint12_linear_107_46780)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M905.234 301.026C911.504 301.026 916.587 295.945 916.587 289.677C916.587 283.409 911.504 278.328 905.234 278.328C898.964 278.328 893.882 283.409 893.882 289.677C893.882 295.945 898.964 301.026 905.234 301.026Z",
    fill: "url(#paint13_linear_107_46780)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M858.804 310.653H852.389V278.313C852.389 271.793 857.692 266.507 864.198 266.507H896.625C903.147 266.507 908.434 271.808 908.434 278.313H902.019C902.019 275.342 899.596 272.92 896.625 272.92H864.198C861.227 272.92 858.804 275.342 858.804 278.313V310.653Z",
    fill: "url(#paint14_linear_107_46780)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M887.284 400.012H875.886V411.665H887.284V400.012Z",
    fill: "url(#paint15_linear_107_46780)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M873.874 374.969H909.273L896.884 403.912H858.972L873.874 374.969Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M880.9 374.969L865.981 403.912H867.566L882.469 374.969H880.9Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M890.789 374.969L875.886 403.912H877.455L892.373 374.969H890.789Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M900.678 374.969L885.775 403.912H887.345L902.263 374.969H900.678Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M873.874 374.969L873.341 376.004H908.175L896.228 403.912H896.884L909.272 374.969H873.874Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M904.701 384.047L905.372 382.494H869.974L869.166 384.047H904.701Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M900.648 392.03L901.318 390.476H865.905L865.112 392.03H900.648Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M897.875 400.012L898.56 398.946H861.532L860.709 400.012H897.875Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M926.873 400.012H915.475V411.665H926.873V400.012Z",
    fill: "url(#paint16_linear_107_46780)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M913.479 374.969H948.877L936.488 403.912H898.561L913.479 374.969Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M920.488 374.969L905.585 403.912H907.155L922.073 374.969H920.488Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M930.393 374.969L915.475 403.912H917.044L931.962 374.969H930.393Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M940.282 374.969L925.364 403.912H926.949L941.852 374.969H940.282Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M913.479 374.969L912.945 376.004H947.764L935.818 403.912H936.488L948.877 374.969H913.479Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M944.306 384.047L944.961 382.494H909.563L908.771 384.047H944.306Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M940.236 392.03L940.907 390.476H905.509L904.701 392.03H940.236Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M937.464 400.012L938.149 398.946H901.136L900.298 400.012H937.464Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M966.461 400.012H955.062V411.665H966.461V400.012Z",
    fill: "url(#paint17_linear_107_46780)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M953.067 374.969H988.465L976.076 403.912H938.148L953.067 374.969Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M960.091 374.969L945.173 403.912H946.758L961.66 374.969H960.091Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M969.981 374.969L955.062 403.912H956.647L971.55 374.969H969.981Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M979.871 374.969L964.968 403.912H966.537L981.44 374.969H979.871Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M953.067 374.969L952.533 376.004H987.368L975.421 403.912H976.076L988.465 374.969H953.067Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M983.894 384.047L984.564 382.494H949.166L948.358 384.047H983.894Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M979.84 392.03L980.495 390.476H945.097L944.305 392.03H979.84Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M977.051 400.012L977.752 398.946H940.724L939.886 400.012H977.051Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M614.719 400.012H603.321V411.665H614.719V400.012Z",
    fill: "url(#paint18_linear_107_46780)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M601.31 374.969H636.723L624.32 403.912H586.407L601.31 374.969Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M608.334 374.969L593.432 403.912H595.001L609.904 374.969H608.334Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M618.224 374.969L603.321 403.912H604.891L619.809 374.969H618.224Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M628.129 374.969L613.211 403.912H614.78L629.699 374.969H628.129Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M601.31 374.969L600.776 376.004H635.611L623.664 403.912H624.319L636.723 374.969H601.31Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M632.152 384.047L632.808 382.494H597.41L596.617 384.047H632.152Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M628.083 392.03L628.754 390.476H593.356L592.548 392.03H628.083Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M625.31 400.012L625.996 398.946H588.983L588.145 400.012H625.31Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M654.308 400.012H642.91V411.665H654.308V400.012Z",
    fill: "url(#paint19_linear_107_46780)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M640.914 374.969H676.312L663.924 403.912H625.996L640.914 374.969Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M647.923 374.969L633.021 403.912H634.59L649.508 374.969H647.923Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M657.828 374.969L642.91 403.912H644.495L659.398 374.969H657.828Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M667.718 374.969L652.8 403.912H654.385L669.287 374.969H667.718Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M640.914 374.969L640.381 376.004H675.215L663.253 403.912H663.924L676.312 374.969H640.914Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M671.741 384.047L672.397 382.494H636.998L636.206 384.047H671.741Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M667.672 392.03L668.343 390.476H632.945L632.152 392.03H667.672Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M664.899 400.012L665.6 398.946H628.571L627.733 400.012H664.899Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M693.912 400.012H682.514V411.665H693.912V400.012Z",
    fill: "url(#paint20_linear_107_46780)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M680.502 374.969H715.901L703.512 403.912H665.6L680.502 374.969Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M687.527 374.969L672.609 403.912H674.194L689.097 374.969H687.527Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M697.417 374.969L682.514 403.912H684.083L698.986 374.969H697.417Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M707.306 374.969L692.403 403.912H693.973L708.891 374.969H707.306Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M680.502 374.969L679.969 376.004H714.803L702.856 403.912H703.512L715.9 374.969H680.502Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M711.329 384.048L712 382.494H676.602L675.794 384.048H711.329Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M707.275 392.03L707.931 390.476H672.533L671.74 392.03H707.275Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M704.487 400.012L705.188 398.946H668.159L667.321 400.012H704.487Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M714.377 82.062L687.192 66.2955L637.181 0L641.524 1.62995L718.186 78.2536L714.377 82.062Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M718.187 78.6497L747.139 66.4783L830.217 66.5544L826.286 69.0527L718.918 83.9814L718.187 78.6497Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M718.765 84.4688L708.891 114.296L654.171 176.783L654.887 172.198L714.27 81.5288L718.765 84.4688Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M722.072 81.5288C722.072 84.2708 719.847 86.4949 717.104 86.4949C714.361 86.4949 712.137 84.2708 712.137 81.5288C712.137 78.7868 714.361 76.5627 717.104 76.5627C719.847 76.5627 722.072 78.7868 722.072 81.5288Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M709.333 369.271H725.211L718.811 78.6953H715.733L709.333 369.271Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M585.28 145.89L564.145 133.627L525.242 82.062L528.625 83.3264L588.252 142.934L585.28 145.89Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M588.252 143.239L610.774 133.764L675.383 133.825L672.336 135.759L588.831 147.382L588.252 143.239Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M588.709 147.763L581.014 170.964L538.469 219.558L539.017 215.993L585.204 145.478L588.709 147.763Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M587.414 149.332C589.543 149.332 591.269 147.607 591.269 145.478C591.269 143.35 589.543 141.624 587.414 141.624C585.285 141.624 583.559 143.35 583.559 145.478C583.559 147.607 585.285 149.332 587.414 149.332Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M581.364 369.271H593.722L588.739 143.27H586.347L581.364 369.271Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M465.92 214.166L450.529 205.239L422.187 167.673L424.655 168.587L468.084 212.002L465.92 214.166Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M468.084 212.231L484.495 205.33L531.551 205.376L529.326 206.792L468.495 215.247L468.084 212.231Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M468.419 215.537L462.812 232.43L431.817 267.833L432.214 265.228L465.859 213.861L468.419 215.537Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M470.278 213.861C470.278 215.415 469.013 216.664 467.474 216.664C465.919 216.664 464.67 215.399 464.67 213.861C464.67 212.307 465.935 211.058 467.474 211.058C469.028 211.058 470.278 212.307 470.278 213.861Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M463.07 376.888H472.061L468.434 212.261H466.697L463.07 376.888Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.97 347.746V337.601H1185.48V347.746H1138.22V383.271H1226.13V347.746H1217.97Z",
    fill: "url(#paint21_linear_107_46780)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.12 364.518H1148.37V382.92H1163.12V364.518Z",
    fill: "url(#paint22_linear_107_46780)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1205.17 345.279L1197.93 362.035H1203.63L1199.12 379.203L1210.51 358.989H1202.86L1205.17 345.279Z",
    fill: "url(#paint23_linear_107_46780)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1192.73 354.358L1187.92 365.493H1191.71L1188.69 376.918L1196.28 363.467H1191.19L1192.73 354.358Z",
    fill: "url(#paint24_linear_107_46780)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.96 376.187H1055.97V415.367H1066.96V376.187Z",
    fill: "url(#paint25_linear_107_46780)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.51 393.416C1081.19 393.416 1096.34 368.222 1096.34 337.144C1096.34 306.066 1081.19 280.872 1062.51 280.872C1043.82 280.872 1028.68 306.066 1028.68 337.144C1028.68 368.222 1043.82 393.416 1062.51 393.416Z",
    fill: "url(#paint26_linear_107_46780)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M452.891 380.666H441.904V419.846H452.891V380.666Z",
    fill: "url(#paint27_linear_107_46780)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M448.442 397.879C467.125 397.879 482.27 372.685 482.27 341.607C482.27 310.529 467.125 285.335 448.442 285.335C429.759 285.335 414.613 310.529 414.613 341.607C414.613 372.685 429.759 397.879 448.442 397.879Z",
    fill: "url(#paint28_linear_107_46780)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.47 462.088H990.187V487.954H1015.47V462.088Z",
    fill: "url(#paint29_linear_107_46780)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M985.737 406.547H1064.29L1036.78 470.756H952.655L985.737 406.547Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1001.31 406.547L968.229 470.756H971.733L1004.82 406.547H1001.31Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1023.27 406.547L990.187 470.756H993.676L1026.76 406.547H1023.27Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1045.21 406.547L1012.13 470.756H1015.63L1048.72 406.547H1045.21Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M985.737 406.547L984.563 408.847H1061.84L1035.32 470.756H1036.78L1064.29 406.547H985.737Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1054.14 426.67L1055.62 423.243H977.066L975.299 426.67H1054.14Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1045.13 444.387L1046.61 440.944H968.061L966.293 444.387H1045.13Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1038.96 462.088L1040.5 459.727H958.354L956.495 462.088H1038.96Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.31 462.088H1078.03V487.954H1103.31V462.088Z",
    fill: "url(#paint30_linear_107_46780)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.6 406.547H1152.14L1124.65 470.756H1040.5L1073.6 406.547Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1089.17 406.547L1056.09 470.756H1059.58L1092.66 406.547H1089.17Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1111.12 406.547L1078.03 470.756H1081.54L1114.62 406.547H1111.12Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1133.07 406.547L1099.99 470.756H1103.48L1136.56 406.547H1133.07Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1073.6 406.547L1072.41 408.847H1149.7L1123.18 470.756H1124.65L1152.14 406.547H1073.6Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1142 426.67L1143.47 423.243H1064.93L1063.15 426.67H1142Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1133 444.387L1134.46 440.944H1055.91L1054.14 444.387H1133Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1126.83 462.088L1128.37 459.727H1046.22L1044.36 462.088H1126.83Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.18 462.088H1165.9V487.954H1191.18V462.088Z",
    fill: "url(#paint31_linear_107_46780)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.45 406.547H1240L1212.5 470.756H1128.37L1161.45 406.547Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1177.02 406.547L1143.94 470.756H1147.43L1180.53 406.547H1177.02Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1198.98 406.547L1165.9 470.756H1169.39L1202.47 406.547H1198.98Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1220.92 406.547L1187.84 470.756H1191.35L1224.43 406.547H1220.92Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1161.45 406.547L1160.27 408.847H1237.55L1211.03 470.756H1212.5L1240 406.547H1161.45Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1229.85 426.67L1231.33 423.243H1152.78L1151.01 426.67H1229.85Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1220.85 444.387L1222.32 440.944H1143.77L1142 444.387H1220.85Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1214.67 462.088L1216.21 459.727H1134.07L1132.21 462.088H1214.67Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M814.278 367.931L760.732 368.296L707.551 526.571H887.878L814.278 367.931Z",
    fill: "#184E51"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M792.198 389.41L791.786 367.931H787.916L787.489 389.41H792.198Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M792.869 424.507L792.32 395.99H787.368L786.819 424.507H792.869Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M793.829 474.229L792.96 429.626H786.728L785.859 474.229H793.829Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M785.615 487.39L784.868 526.57H794.834L794.072 487.39H785.615Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.09 426.762H1292.78V484.907H1309.09V426.762Z",
    fill: "url(#paint32_linear_107_46780)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1302.49 452.323C1330.22 452.323 1352.7 414.921 1352.7 368.784C1352.7 322.646 1330.22 285.244 1302.49 285.244C1274.76 285.244 1252.28 322.646 1252.28 368.784C1252.28 414.921 1274.76 452.323 1302.49 452.323Z",
    fill: "url(#paint33_linear_107_46780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_46780",
    x1: 512.952,
    y1: 225.626,
    x2: 1093.9,
    y2: 225.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_46780",
    x1: 320.882,
    y1: 280.594,
    x2: 793.905,
    y2: 280.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_46780",
    x1: 793.904,
    y1: 280.594,
    x2: 1266.93,
    y2: 280.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_46780",
    x1: 182,
    y1: 439.57,
    x2: 220.488,
    y2: 478.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_46780",
    x1: 157.518,
    y1: 320.048,
    x2: 254.996,
    y2: 417.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_46780",
    x1: 559.665,
    y1: 339.44,
    x2: 601.428,
    y2: 339.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_107_46780",
    x1: 610.932,
    y1: 339.44,
    x2: 652.696,
    y2: 339.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_107_46780",
    x1: 662.2,
    y1: 339.44,
    x2: 703.964,
    y2: 339.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_107_46780",
    x1: 579.394,
    y1: 301.839,
    x2: 683.999,
    y2: 301.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_107_46780",
    x1: 945.795,
    y1: 353.706,
    x2: 1037.47,
    y2: 353.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_107_46780",
    x1: 955.506,
    y1: 365.042,
    x2: 968.783,
    y2: 365.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_107_46780",
    x1: 875.935,
    y1: 332.57,
    x2: 936.953,
    y2: 332.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_107_46780",
    x1: 829.709,
    y1: 343.242,
    x2: 881.482,
    y2: 343.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_107_46780",
    x1: 893.882,
    y1: 289.672,
    x2: 916.59,
    y2: 289.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_107_46780",
    x1: 852.385,
    y1: 288.582,
    x2: 908.447,
    y2: 288.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_107_46780",
    x1: 881.576,
    y1: 411.66,
    x2: 881.576,
    y2: 400.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_107_46780",
    x1: 921.17,
    y1: 411.66,
    x2: 921.17,
    y2: 400.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_107_46780",
    x1: 960.764,
    y1: 411.66,
    x2: 960.764,
    y2: 400.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_107_46780",
    x1: 609.013,
    y1: 411.66,
    x2: 609.013,
    y2: 400.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_107_46780",
    x1: 648.608,
    y1: 411.66,
    x2: 648.608,
    y2: 400.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_107_46780",
    x1: 688.202,
    y1: 411.66,
    x2: 688.202,
    y2: 400.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_107_46780",
    x1: 1047.47,
    y1: 360.438,
    x2: 1226.14,
    y2: 360.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0758,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5983,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_107_46780",
    x1: 1135.19,
    y1: 368.572,
    x2: 1142.78,
    y2: 390.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_107_46780",
    x1: 1186.68,
    y1: 352.752,
    x2: 1208.28,
    y2: 381.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_107_46780",
    x1: 1180.44,
    y1: 359.327,
    x2: 1194.81,
    y2: 378.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_107_46780",
    x1: 1046.15,
    y1: 384.818,
    x2: 1072.08,
    y2: 410.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_107_46780",
    x1: 1029.66,
    y1: 304.307,
    x2: 1095.32,
    y2: 369.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_107_46780",
    x1: 432.086,
    y1: 389.296,
    x2: 458.02,
    y2: 415.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_107_46780",
    x1: 415.593,
    y1: 308.777,
    x2: 481.259,
    y2: 374.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_107_46780",
    x1: 1002.82,
    y1: 487.956,
    x2: 1002.82,
    y2: 462.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_107_46780",
    x1: 1090.67,
    y1: 487.956,
    x2: 1090.67,
    y2: 462.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_107_46780",
    x1: 1178.53,
    y1: 487.956,
    x2: 1178.53,
    y2: 462.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2167,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5299,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7083,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_107_46780",
    x1: 1278.21,
    y1: 439.57,
    x2: 1316.7,
    y2: 478.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027933,
    stopColor: "#FD8BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    stopColor: "#FE8ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7288,
    stopColor: "#FE8393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7E43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_107_46780",
    x1: 1253.73,
    y1: 320.048,
    x2: 1351.21,
    y2: 417.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFrame);
export default __webpack_public_path__ + "static/media/home_frame.a55149c7fd00ecb59e35e42d27ab6fce.svg";
export { ForwardRef as ReactComponent };